'use client'

import { useEffect } from 'react'

import { AppErrorFallback } from '@/components/misc/app-error-fallback'
import { fontVariables } from '@/lib/fonts'
import { reportClientCrash } from '@/lib/ops/report-client-crash'
import { cn } from '@/lib/utils'

import './globals.css'

interface GlobalErrorPageProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function GlobalErrorPage({
  error,
  reset,
}: GlobalErrorPageProps) {
  useEffect(() => {
    reportClientCrash(error, {
      digest: error.digest,
      source: 'global-error',
    })
  }, [error])

  return (
    <html lang="en" suppressHydrationWarning>
      <body className={cn('font-sans antialiased', fontVariables)}>
        <AppErrorFallback
          title="Something went wrong"
          description="The application failed to load. Try again, or return home if the problem continues."
          digest={error.digest}
          onRetry={reset}
        />
      </body>
    </html>
  )
}
